import { captureException } from '@mentimeter/errors/sentry';
import { MentiError } from '@mentimeter/error-utils/error';
import { defer } from './defer';

export function visualizationUpdater() {
  const deferUpdate = defer();
  return function (updateFn: () => Promise<any>) {
    return deferUpdate.run(() => {
      return updateFn().catch((e) => {
        captureException(
          new MentiError(e, {
            feature: 'slides',
            cause: e,
          }),
        );
      });
    });
  };
}
